const PATH = 'fe.pages.reports.observation_v2';

const messages = {
  backToReport: {
    key: `${PATH}.back_to_report`,
    defaultValue: 'Back to Report'
  },
  back: {
    key: `${PATH}.back`,
    defaultValue: 'Back'
  },
  generateReport: {
    key: `${PATH}.generate_report`,
    defaultValue: 'Generate Report'
  },
  addComparison: {
    key: `${PATH}.add_comparison`,
    defaultValue: 'Add Comparison'
  },
  configNumber: {
    key: `${PATH}.config_number`,
    defaultValue: 'Configuration {{count}}'
  },
  noAssessmentTemplates: {
    key: `${PATH}.no_assessment_templates`,
    defaultValue:
      "Uh oh! This account doesn't have any CLASS assessment templates configured. Please contact Teachstone for support."
  }
};

export default messages;
